<template>
    <v-overlay :value="open" z-index="1000">
        <v-alert :type="messageType" prominent>
            {{ message }}
        </v-alert>
    </v-overlay> 
</template>
<script>
    export default {
        name: "LoadingSendingMail",
        data(){
            return {
                messageType: "",
                message: "",
                open: false,
                duration: 3000,
            };
        },
        methods: {
            showOverlay(type, message, duration=3000) {
                this.messageType = type;
                this.message = message;
                this.duration = duration;
                this.open=true;
            },
        }, 
        watch: {
            open (val) {
                val && setTimeout(() => {
                    this.open = false;
                    this.$emit("end");
                    if(this.messageType=="success")
                        this.$emit("endSuccess");
                    if(this.messageType=="error")
                        this.$emit("endError");
                    
                }, this.duration)
            },
        },
    }
    
</script>